import { useRecoilValue } from 'recoil';
import {
    isroResultState,
    isroSelectedSampleNumberState,
} from '~/state/atoms/isroResultAtoms';

export interface ImageRoleLabel {
    readonly id: string;
    readonly values?: Record<string, number>;
}

// While a sample is compared, its reference scan and every sample are named for their role.
export function useIsroImageLabel(
    seriesUid: string | undefined
): ImageRoleLabel | null {
    const result = useRecoilValue(isroResultState);
    const selectedNumber = useRecoilValue(isroSelectedSampleNumberState);
    if (!result || !seriesUid) {
        return null;
    }
    const sample = result.samples.find(
        (candidate) => candidate.seriesUid === seriesUid
    );
    if (sample) {
        return { id: 'isro.sample', values: { n: sample.number } };
    }
    return selectedNumber !== null && seriesUid === result.referenceSeriesUid
        ? { id: 'isro.panel.reference' }
        : null;
}
